var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"local-lm-left-menu"},[_c('div',{staticClass:"level local-lm-logo"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('figure',{staticClass:"image is-64x64"},[_c('router-link',{attrs:{"to":{ name: 'Orders' }}},[_c('img',{attrs:{"src":_vm.loadLogo}})])],1)])]),_vm._v(" "),_c('dashboard-menu')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-499315fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/LeftMenu.vue
// module id = null
// module chunks = 